<template>
  <div class="page-card">
    <div class="title">我的会员卡({{cardList.length}})</div>
    <div class="list">
      <div class="item" v-for="(item, index) in cardList" :key="index">
        <div class="bg" v-if="item.overTime < 0"></div>
        <img :src="item.card_info.bg_img_path" class="bg-cover" alt="">
        <div class="itme-title">{{ item.card_info.title }}</div>
        <div class="txt1">{{ item.card_info.desc1 }}</div>
        <div class="txt2" v-if="item.overTime > 0">{{ item.end_time }} 到期 {{ item.overTime > 3 * 24 * 60 * 60 * 1000 ? '' : `还有${new Date(item.overTime).getDate()}天到期请尽快续费` }}</div>
        <div class="txt3" v-else>已到期，续费立享特权</div>
        <div @click="handleJump('vipTypeInfo', item)" class="btn" v-if="item.overTime > 3 * 24 * 60 * 60 * 1000">查看权益</div>
        <div @click="handleJump()" class="btn status1 status2" v-else-if="item.overTime < 0">立即续费</div>
        <div @click="handleJump()" class="btn status1" v-else>立即续费</div>
      </div>
    </div>
  </div>
</template>
<script>
import { cards } from '@/api/person'
export default {
  name: 'PageCard',
  data () {
    return {
      cardList: []
    }
  },
  computed: {
    userInfo () {
      return JSON.parse(this.$ls.storage['xingfugongshe_user-info']).value
    }
  },
  mounted () {
    this.handleFunc()
  },
  methods: {
    handleFunc () {
      cards().then(res => {
        this.cardList = res.data.map(item => {
          item.overTime = new Date(item.end_time).getTime() - new Date().getTime()
          console.log(item.overTime, new Date(item.end_time).getTime(), new Date().getTime())
          return item
        })
      })
    },
    handleJump(type, item) {
      if (type === 'vipTypeInfo') {
        this.$router.push({
          path: `/vipTypeInfo?level_type=${item.level_type}&level=${item.level}`
        })
        return
      }
      this.$router.push({
        path: '/openMenber'
      })
    }
  }
}
</script>
<style lang="less" scoped>
.page-card {
  width: 100vw;
  min-height: 100vh;
  background-color: #1E2020;
  overflow-x: hidden;

  .title {
    font-size: 20px;
    color: #FFFFFF;
    font-weight: 600;
    padding: 30px 14px;
    padding-bottom: 20px;
    line-height: 20px;
    box-sizing: border-box;
  }

  .list {
    .item {
      width: 100%;
      height: 132px;
      position: relative;
      margin-bottom: 20px;
      .bg {
        width: calc(100% - 28px);
        position: absolute;
        z-index: 5;
        height: 100%;
        background-color: rgba(0,0,0, .5);
        margin: 0 14px;
        left: 0;
        border-radius: 12px 12px 0px 0px;
      }
      .bg-cover {
        width: 100%;
        padding: 0 8px;
        box-sizing: border-box;
        position: absolute;
        top: 0;
        left: 0;
      }

      .itme-title {
        font-size: 12px;
        color: #FFFFFF;
        line-height: 12px;
        position: absolute;
        top: 22.5px;
        left: 134px;
      }

      .txt1 {
        position: relative;
        left: 28px;
        top: 62px;
        font-size: 20px;
        color: #F0E1C0;
        line-height: 28px;
      }

      .txt2 {
        color: #FFFFFF;
        font-size: 12px;
        left: 28px;
        position: relative;
        top: 72px;
        line-height: 12px;
      }

      .txt3 {
        font-size: 12px;
        color: #F0E1C0;
        font-weight: 600;
        line-height: 12px;
        left: 28px;
        position: relative;
        top: 72px;
      }

      .btn {
        width: 102px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        border-radius: 100px;
        background-color: #fff;
        color: #504632;
        font-size: 14px;
        font-weight: 500;
        position: relative;
        top: 13px;
        left: 245px;

        &.status1 {
          background-color: #F0E1C0;
          &.status2 {
            z-index: 9;
          }
        }
      }
    }
  }
}</style>



// WEBPACK FOOTER //
// src/views/pageCard.vue